import { Accordion, AccordionSummary, AccordionDetails, Typography, Box } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useTranslation } from "react-i18next";
import CommentsTable from "./CommentsTable";
import CustomButton from "components/Button";
import GenerateCommentModal from "./GenerateCommentModal";
import { useState } from "react";
import AddCommentModal from "./AddCommentModal";

interface IComments {
  languages: any;
}

export default function Comments({ languages }: IComments) {
  const { t } = useTranslation();
  const [generatecomment, setGeneratecomment] = useState(false);
  const [addComments, setaddComments] = useState(false);

  const handleAddComments = () => {
    setaddComments(true);
  };

  const handleGeneratecomment = () => {
    setGeneratecomment(true);
  };
  return (
    <>
      <Accordion
        sx={{
          boxShadow: "none",
          border: "1px solid #EEEEEE",
          borderRadius: "8px",
          "&::before": { display: " none" },
        }}
      >
        <AccordionSummary
          sx={{ padding: { xs: "0px 16px", md: "0px 20px" }, height: { xs: "56px", md: "64px" } }}
          expandIcon={<ExpandMoreIcon />}
        >
          <Typography sx={{ fontSize: "16px", fontFamily: "var(--cygreRegular), sans-serif", color: "#2e263d" }}>
            {t("comments")}
          </Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ padding: { xs: "0px 16px 16px 16px", md: "0px 20px 20px 20px" } }}>
          <CommentsTable />
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              gap: "12px",
              marginTop: "20px",
              justifyContent: "space-between",
            }}
          >
            <CustomButton
              textButton={t("generatecomment")}
              height={40}
              customColor="#FFFFFF"
              customBgColor="#2E263D"
              customBorderRadius="8px"
              customHoverColor="#2E263D"
              customFontSize="15px"
              customTextTransform="none"
              width={"100%"}
              onClick={handleGeneratecomment}
            />
            <CustomButton
              textButton={t("addmanualcomment")}
              height={40}
              width={"100%"}
              customColor="#6D6777"
              customBorderColor="#C9D0D8"
              customHoverColor="transparent"
              customBorderRadius="8px"
              customFontSize="15px"
              customTextTransform="none"
              onClick={handleAddComments}
            />
          </Box>
        </AccordionDetails>
      </Accordion>
      <GenerateCommentModal open={generatecomment} setOpen={setGeneratecomment} languages={languages} />
      <AddCommentModal
        title={t("addingcomment")}
        open={addComments}
        setOpen={setaddComments}
        translations={undefined}
        languages={undefined}
      />
    </>
  );
}
